import { cardsData, contactData, aboutData, faqData, commentsData } from '@/mocks/home';

export function CardsSection() {
  return (
    <section id='cards' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          精选推荐
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          综艺深度内容 · 精彩不容错过
        </p>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5'>
          {cardsData.slice(0, 6).map((item) => (
            <div
              key={item.title}
              className='group bg-background-100 rounded-xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer'
            >
              <div className='relative w-full aspect-[3/2] overflow-hidden bg-background-200'>
                <img
                  src={item.image}
                  alt={item.title}
                  className='w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500'
                />
                <span className='absolute top-2 left-2 px-2 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap'>
                  {item.tag}
                </span>
              </div>
              <div className='p-3 md:p-4'>
                <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900 mb-1.5 line-clamp-2'>
                  {item.title}
                </h3>
                <p className='text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2'>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
          <div className='bg-background-100 rounded-xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer'>
            <div className='relative w-full aspect-[3/2] overflow-hidden bg-background-200'>
              <img
                src='https://readdy.ai/api/search-image?query=Vintage%20vinyl%20records%20and%20retro%20microphone%20on%20wooden%20table%2C%20warm%20nostalgic%20lighting%2C%20music%20studio%20atmosphere%2C%20classic%20meets%20modern%20aesthetic%2C%20professional%20photography%20with%20rich%20golden%20and%20amber%20tones%2C%20soft%20shadows&width=640&height=420&seq=card-07&orientation=landscape'
                alt='《声生不息》港乐金曲重温'
                className='w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500'
              />
              <span className='absolute top-2 left-2 px-2 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap'>
                音乐特辑
              </span>
            </div>
            <div className='p-3 md:p-4'>
              <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900 mb-1.5 line-clamp-2'>
                《声生不息》港乐金曲重温
              </h3>
              <p className='text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2'>
                那些年我们追过的港乐经典，《声生不息》舞台让这些金曲重获新生。盘点节目中最催泪的十个经典翻唱现场。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id='contact' className='py-10 md:py-16 px-4 md:px-6 bg-background-100'>
      <div className='w-full max-w-3xl mx-auto text-center'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2'>
          联系我们
        </h2>
        <p className='text-sm text-foreground-500 mb-6 md:mb-8'>
          {contactData.hint}
        </p>
        <div className='bg-background-50 rounded-2xl p-6 md:p-10'>
          <p className='text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-lg mx-auto'>
            {contactData.description}
          </p>
          <div className='flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8'>
            <div className='flex items-center gap-3 px-5 py-3 bg-background-100 rounded-xl'>
              <i className='ri-mail-line text-primary-500 text-xl'></i>
              <div className='text-left'>
                <p className='text-xs text-foreground-400'>邮箱</p>
                <p className='text-sm font-medium text-foreground-800'>{contactData.email}</p>
              </div>
            </div>
            <div className='flex items-center gap-3 px-5 py-3 bg-background-100 rounded-xl'>
              <i className='ri-wechat-line text-primary-500 text-xl'></i>
              <div className='text-left'>
                <p className='text-xs text-foreground-400'>微信</p>
                <p className='text-sm font-medium text-foreground-800'>{contactData.wechat}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id='about' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-4xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          关于我们
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          了解97在线影院 · 综艺在线观看平台
        </p>
        <div className='bg-background-100 rounded-2xl p-6 md:p-10'>
          <div className='whitespace-pre-line text-sm md:text-base text-foreground-700 leading-relaxed mb-8'>
            {aboutData.description}
          </div>
          <div className='grid grid-cols-3 gap-4 md:gap-6'>
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className='text-center p-4 bg-background-50 rounded-xl'>
                <p className='font-heading text-2xl md:text-4xl font-bold text-primary-500 mb-1'>{stat.value}</p>
                <p className='text-xs md:text-sm text-foreground-500'>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  return (
    <section id='faq' className='py-10 md:py-16 px-4 md:px-6 bg-background-100'>
      <div className='w-full max-w-3xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          常见问题
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          关于综艺在线观看的常见疑问
        </p>
        <div className='flex flex-col gap-3 md:gap-4'>
          {faqData.map((faq, idx) => (
            <div key={idx} className='bg-background-50 rounded-xl p-4 md:p-6'>
              <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900 mb-2'>
                {faq.question}
              </h3>
              <p className='text-xs md:text-sm text-foreground-600 leading-relaxed'>
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id='comments' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-4xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          用户评价
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          综艺爱好者真实反馈 · 听听他们怎么说
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5'>
          {commentsData.map((comment) => (
            <div key={comment.name} className='bg-background-100 rounded-xl p-4 md:p-5'>
              <div className='flex items-center gap-3 mb-3'>
                <div className='w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0'>
                  <i className='ri-user-3-line text-primary-500 text-lg'></i>
                </div>
                <div>
                  <p className='font-heading text-sm font-bold text-foreground-900'>{comment.name}</p>
                  <div className='flex items-center gap-1'>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < comment.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className='ml-auto text-xs text-foreground-400 whitespace-nowrap'>{comment.date}</span>
              </div>
              <p className='text-xs md:text-sm text-foreground-700 leading-relaxed'>
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}